import { TableColumn } from '../models/table-column.model';

/** Fila de la tabla "Revisión planes de acción" (pantalla 7.7). */
export interface IActionPlanRow {
  region: string;
  zona: string;
  sucursal: string;
  usuario: string;
  /** Calificación de recomendación (0-10) capturada en la encuesta. */
  rec: number;
  comentario: string;
  /** Formato dd/mm/yyyy. Vacío cuando el plan aún no tiene compromiso. */
  fechaCompromiso: string;
  planAccion: string;
}

export const COLUMNAS_PLANES: Array<TableColumn> = [
  { key: 'region',          title: 'REGIÓN',           headerStyle: 'teal', width: '150px' },
  { key: 'zona',            title: 'ZONA',             headerStyle: 'teal', width: '160px' },
  { key: 'sucursal',        title: 'SUCURSAL',         headerStyle: 'teal', width: '170px' },
  { key: 'usuario',         title: 'USUARIO',          headerStyle: 'teal', width: '140px' },
  { key: 'rec',             title: 'REC.',             headerStyle: 'teal', cellStyle: 'center', width: '70px' },
  { key: 'comentario',      title: 'COMENTARIO',       headerStyle: 'teal', width: '300px' },
  { key: 'fechaCompromiso', title: 'FECHA COMPROMISO', headerStyle: 'teal', cellStyle: 'center', width: '130px' },
  { key: 'planAccion',      title: 'PLAN DE ACCIÓN',   headerStyle: 'teal', width: '280px' },
];

/**
 * Cuarenta y cuatro planes abiertos sobre las diecinueve sucursales del filtro.
 * Región y zona salen del árbol de `jerarquia.data.ts`, así que filtrar por
 * región devuelve exactamente las zonas que le cuelgan.
 */
export const PLANES_ACCION: Array<IActionPlanRow> = [
  {
    region: 'ATANACIO MENDOZA', zona: 'GUILLERMO MARTINEZ', sucursal: 'SUCURSAL ALTA TENSION 3',
    usuario: 'admin', rec: 2,
    comentario: 'Falta orden en los anaqueles, los productos están revueltos',
    fechaCompromiso: '04/08/2026',
    planAccion: 'Se levantó acta administrativa y se recapacitó al colaborador en trato al cliente',
  },
  {
    region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL AVENIDA CENTRAL',
    usuario: 'renata.quiroz', rec: 3,
    comentario: '',
    fechaCompromiso: '09/08/2026',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ELEAZAR GARCIA', sucursal: 'SUCURSAL ECATEPEC',
    usuario: 'humberto.salas', rec: 1,
    comentario: 'No son competitivos en precio contra la central',
    fechaCompromiso: '',
    planAccion: 'Se solicitan 30 carritos nuevos y reparación de los existentes',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL TOLUCA 1',
    usuario: 'Dirección general', rec: 1,
    comentario: 'Siempre falta producto de cremería los fines de semana',
    fechaCompromiso: '10/08/2026',
    planAccion: 'Se programa mantenimiento del equipo de clima con el proveedor externo',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL AMECAMECA',
    usuario: 'admin', rec: 1,
    comentario: 'Las cajas tardan demasiado los sábados',
    fechaCompromiso: '18/07/2026',
    planAccion: 'Se notifica a la empresa de seguridad y se cambia al elemento de la sucursal',
  },
  {
    region: 'LEONARDO MAXIMO', zona: 'ISMAEL FERMIN', sucursal: 'SUCURSAL AZTAHUACAN',
    usuario: 'renata.quiroz', rec: 6,
    comentario: '',
    fechaCompromiso: '',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL IGUALA 2',
    usuario: 'humberto.salas', rec: 1,
    comentario: 'Me cobraron distinto a lo que decía el anaquel',
    fechaCompromiso: '08/08/2026',
    planAccion: 'Se habilita el módulo de facturación en línea y se avisa al cliente por correo',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL TULTITLAN',
    usuario: 'Dirección general', rec: 1,
    comentario: 'Los carritos están descompuestos casi todos',
    fechaCompromiso: '10/08/2026',
    planAccion: 'Se rediseñan las cenefas de promoción incluyendo vigencia y letra chica',
  },
  {
    region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ARAGÓN',
    usuario: 'admin', rec: 4,
    comentario: 'Hace mucho calor dentro de la tienda',
    fechaCompromiso: '',
    planAccion: 'Se habilita una segunda báscula en granel y se asigna personal fijo al turno',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ELEAZAR GARCIA', sucursal: 'SUCURSAL CAZADOR',
    usuario: 'renata.quiroz', rec: 1,
    comentario: '',
    fechaCompromiso: '08/08/2026',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL LEON 2',
    usuario: 'humberto.salas', rec: 0,
    comentario: 'No aceptan tarjeta cuando se cae el sistema',
    fechaCompromiso: '17/07/2026',
    planAccion: 'Se cambia de proveedor de frutas y verduras en la plaza',
  },
  {
    region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL ALTA TENSION',
    usuario: 'Dirección general', rec: 3,
    comentario: 'Tardan mucho en facturar y hay que volver otro día',
    fechaCompromiso: '',
    planAccion: 'Se asigna un auxiliar de piso al área de bultos en horario matutino',
  },
  {
    region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ATIZAPAN 2',
    usuario: 'admin', rec: 1,
    comentario: 'La promoción anunciada no aplicaba y nadie avisó',
    fechaCompromiso: '25/07/2026',
    planAccion: 'Se reabren los sanitarios de clientes con limpieza por turno',
  },
  {
    region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL CAZADOR NAUCALPAN',
    usuario: 'renata.quiroz', rec: 6,
    comentario: '',
    fechaCompromiso: '06/08/2026',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL MARIANO ESCOBEDO LEON',
    usuario: 'humberto.salas', rec: 4,
    comentario: 'Faltan cajas abiertas en horario pico',
    fechaCompromiso: '',
    planAccion: 'Se reprograma el descanso del montacarguista para no dejar el andén solo',
  },
  {
    region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ALTA TENSION 2',
    usuario: 'Dirección general', rec: 3,
    comentario: 'La verdura llega maltratada casi siempre',
    fechaCompromiso: '24/07/2026',
    planAccion: 'Se replantea el acomodo del pasillo central para liberar el paso',
  },
  {
    region: 'ATANACIO MENDOZA', zona: 'GUILLERMO MARTINEZ', sucursal: 'SUCURSAL AV. 11 SUR',
    usuario: 'admin', rec: 2,
    comentario: 'No hay quien ayude a cargar bultos pesados',
    fechaCompromiso: '04/08/2026',
    planAccion: 'Se levanta orden de servicio para el equipo de refrigeración',
  },
  {
    region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL CHALCO',
    usuario: 'renata.quiroz', rec: 5,
    comentario: '',
    fechaCompromiso: '',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL PROFETA',
    usuario: 'humberto.salas', rec: 1,
    comentario: 'El precio de mayoreo no lo respetan en caja',
    fechaCompromiso: '12/07/2026',
    planAccion: 'Alerta enviada a la sucursal por ORDEN_LIMPIEZA',
  },
  {
    region: 'ATANACIO MENDOZA', zona: 'GUILLERMO MARTINEZ', sucursal: 'SUCURSAL ALTA TENSION 3',
    usuario: 'Dirección general', rec: 5,
    comentario: 'El andén de carga está sin personal a media tarde',
    fechaCompromiso: '23/07/2026',
    planAccion: 'Alerta enviada a la sucursal por ATENCION_PERSONAL',
  },
  {
    region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL AVENIDA CENTRAL',
    usuario: 'admin', rec: 3,
    comentario: 'Los pasillos están bloqueados con tarimas',
    fechaCompromiso: '',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ELEAZAR GARCIA', sucursal: 'SUCURSAL ECATEPEC',
    usuario: 'renata.quiroz', rec: 4,
    comentario: '',
    fechaCompromiso: '04/08/2026',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL TOLUCA 1',
    usuario: 'humberto.salas', rec: 5,
    comentario: 'Falta orden en los anaqueles, los productos están revueltos',
    fechaCompromiso: '20/07/2026',
    planAccion: 'Se levantó acta administrativa y se recapacitó al colaborador en trato al cliente',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL AMECAMECA',
    usuario: 'Dirección general', rec: 4,
    comentario: 'Todo el personal es apático, nadie voltea a ver al cliente',
    fechaCompromiso: '',
    planAccion: 'Se contactó al cliente, se hizo el reembolso y se documentó el caso con el gerente',
  },
  {
    region: 'LEONARDO MAXIMO', zona: 'ISMAEL FERMIN', sucursal: 'SUCURSAL AZTAHUACAN',
    usuario: 'admin', rec: 6,
    comentario: 'No son competitivos en precio contra la central',
    fechaCompromiso: '18/07/2026',
    planAccion: 'Se solicitan 30 carritos nuevos y reparación de los existentes',
  },
  {
    region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL IGUALA 2',
    usuario: 'renata.quiroz', rec: 3,
    comentario: '',
    fechaCompromiso: '09/08/2026',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL TULTITLAN',
    usuario: 'humberto.salas', rec: 5,
    comentario: 'Las cajas tardan demasiado los sábados',
    fechaCompromiso: '',
    planAccion: 'Se notifica a la empresa de seguridad y se cambia al elemento de la sucursal',
  },
  {
    region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ARAGÓN',
    usuario: 'Dirección general', rec: 2,
    comentario: 'El estacionamiento está lleno de baches',
    fechaCompromiso: '04/08/2026',
    planAccion: 'Se instala terminal con respaldo de datos móviles y señalización en cajas',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ELEAZAR GARCIA', sucursal: 'SUCURSAL CAZADOR',
    usuario: 'admin', rec: 6,
    comentario: 'Me cobraron distinto a lo que decía el anaquel',
    fechaCompromiso: '27/07/2026',
    planAccion: 'Se habilita el módulo de facturación en línea y se avisa al cliente por correo',
  },
  {
    region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL LEON 2',
    usuario: 'renata.quiroz', rec: 2,
    comentario: '',
    fechaCompromiso: '',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL ALTA TENSION',
    usuario: 'humberto.salas', rec: 5,
    comentario: 'Hace mucho calor dentro de la tienda',
    fechaCompromiso: '12/07/2026',
    planAccion: 'Se habilita una segunda báscula en granel y se asigna personal fijo al turno',
  },
  {
    region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ATIZAPAN 2',
    usuario: 'Dirección general', rec: 4,
    comentario: 'El guardia de la entrada trata mal a los clientes',
    fechaCompromiso: '22/07/2026',
    planAccion: 'Se ajusta el rol de cajas para cubrir el pico de sábado y domingo',
  },
  {
    region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL CAZADOR NAUCALPAN',
    usuario: 'admin', rec: 1,
    comentario: 'No aceptan tarjeta cuando se cae el sistema',
    fechaCompromiso: '',
    planAccion: 'Se cambia de proveedor de frutas y verduras en la plaza',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL MARIANO ESCOBEDO LEON',
    usuario: 'renata.quiroz', rec: 3,
    comentario: '',
    fechaCompromiso: '16/07/2026',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'ATANACIO MENDOZA', zona: 'ERIKA MARTINEZ', sucursal: 'SUCURSAL ALTA TENSION 2',
    usuario: 'humberto.salas', rec: 5,
    comentario: 'La promoción anunciada no aplicaba y nadie avisó',
    fechaCompromiso: '19/07/2026',
    planAccion: 'Se reabren los sanitarios de clientes con limpieza por turno',
  },
  {
    region: 'ATANACIO MENDOZA', zona: 'GUILLERMO MARTINEZ', sucursal: 'SUCURSAL AV. 11 SUR',
    usuario: 'Dirección general', rec: 1,
    comentario: 'El área de granel siempre tiene una sola báscula',
    fechaCompromiso: '',
    planAccion: 'Se capacita a cajas sobre el mínimo de piezas del precio de mayoreo',
  },
  {
    region: 'MARTIN MARIN', zona: 'SILVIA ALONSO', sucursal: 'SUCURSAL CHALCO',
    usuario: 'admin', rec: 1,
    comentario: 'Faltan cajas abiertas en horario pico',
    fechaCompromiso: '03/08/2026',
    planAccion: 'Se reprograma el descanso del montacarguista para no dejar el andén solo',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ENRIQUE GONZALEZ', sucursal: 'SUCURSAL PROFETA',
    usuario: 'renata.quiroz', rec: 6,
    comentario: '',
    fechaCompromiso: '17/07/2026',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'ATANACIO MENDOZA', zona: 'GUILLERMO MARTINEZ', sucursal: 'SUCURSAL ALTA TENSION 3',
    usuario: 'humberto.salas', rec: 5,
    comentario: 'No hay quien ayude a cargar bultos pesados',
    fechaCompromiso: '',
    planAccion: 'Se levanta orden de servicio para el equipo de refrigeración',
  },
  {
    region: 'OTILIO MACHUCA', zona: 'VERONICA HERRERA', sucursal: 'SUCURSAL AVENIDA CENTRAL',
    usuario: 'Dirección general', rec: 3,
    comentario: 'Los baños de clientes llevan meses cerrados',
    fechaCompromiso: '03/08/2026',
    planAccion: 'Se bacheó el estacionamiento y se repintó el señalamiento',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ELEAZAR GARCIA', sucursal: 'SUCURSAL ECATEPEC',
    usuario: 'admin', rec: 5,
    comentario: 'El precio de mayoreo no lo respetan en caja',
    fechaCompromiso: '26/07/2026',
    planAccion: 'Alerta enviada a la sucursal por ORDEN_LIMPIEZA',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL TOLUCA 1',
    usuario: 'renata.quiroz', rec: 0,
    comentario: '',
    fechaCompromiso: '',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'ALFONSO VEGA', zona: 'ALICIA VALENCIA', sucursal: 'SUCURSAL AMECAMECA',
    usuario: 'humberto.salas', rec: 1,
    comentario: 'Los pasillos están bloqueados con tarimas',
    fechaCompromiso: '30/07/2026',
    planAccion: 'Registro sin comentario',
  },
  {
    region: 'LEONARDO MAXIMO', zona: 'ISMAEL FERMIN', sucursal: 'SUCURSAL AZTAHUACAN',
    usuario: 'Dirección general', rec: 1,
    comentario: 'El refrigerador de lácteos no enfría bien',
    fechaCompromiso: '12/07/2026',
    planAccion: 'Sin detalles',
  },
];
